import gql from 'graphql-tag';
import { MEDIA_FRAGMENT, IMAGE_FRAGMENT } from './fragments';

export const getUser = gql`
  query {
    user: getUser {
      tritonToken {
        token
        ttl
      }
    }
  }
`;

export const getPodcasts = gql`
  query GetPodcasts($slug: String!) {
    collection(slug: $slug) {
      ... on PodcastCollection {
        id
        title
        slug
        description
        options
        items {
          title
          description
          slug
          id
          subTitle
          type
          tags {
            slug
            title
            type
          }
          episodes(limit: 3) {
            id
            media {
              ...MediaFragment
            }
            type
            title
            description
            publishDate
            durationSeconds
          }
          images {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${MEDIA_FRAGMENT}
  ${IMAGE_FRAGMENT}
`;

export const getFavoriteStations = gql`
  query GetFavoriteStations ($slug: String!) {
    collection(slug: $slug){
      ... on StationCollection {
      id
      slug
      items {
        id,
        slug,
        title,
        shortTitle,
        type
        media {
          ...MediaFragment
        },
        images {
          ...ImageFragment
        }
        config {
          type
          entries {
            key
            value
            type
          }
        }
        userPreference{
          favourite
        }
      }
    }
  }
}
  ${IMAGE_FRAGMENT},
  ${MEDIA_FRAGMENT}
`;

export const getFavoritePodcasts = gql`
  query GetFavoritePodcasts($slug: String!) {
    collection(slug: $slug) {
      ... on PodcastCollection {
        id
        slug
        items {
          id
          slug
          title
          subTitle
          type
          images {
            ...ImageFragment
          }
          userPreference {
            favourite
          }
        }
      }
    }
  }
  ${IMAGE_FRAGMENT}
`;

export const getFavorites = gql`
  query GetFavorites($podcastsSlug: String!, $stationsSlug: String!, $clipsSlug: String!) {
    podcasts: collection(slug: $podcastsSlug) {
      ... on PodcastCollection {
        items {
          id
          slug
          userPreference {
            favourite
          }
        }
      }
    }
    stations: collection(slug: $stationsSlug) {
      ... on StationCollection {
        items {
          id
          slug
          userPreference {
            favourite
          }
        }
      }
    }
    clips: collection(slug: $clipsSlug) {
      ... on ClipCollection {
        items {
          id
          slug
          userPreference {
            favourite
          }
        }
      }
    }
  }
`;

export const setFavorite = gql`
  mutation SetFavourite($userPreference: InputUserPreference!) {
    userPreference(userPreference: $userPreference) {
      id
      type
      userId
      contentId
      contentType
      favourite
    }
  }
`;

export const createProgress = gql`
  mutation createProgress($inputProgress: InputProgress) {
    progress(input: $inputProgress) {
      id
      type
      userId
      contentId
      contentType
      contentLength
      durationLength
      completed
    }
  }
`;
